export default __webpack_public_path__ + "static/media/image.7fa736ca.svg";